import type { Location } from 'modules/core/lib/navigation/types'

export const filesNavigation = {
  path: 'files',
  children: {
    companyFiles: {
      path: 'company-files',
      size: 'full',
      children: {
        list: {
          path: 'list',
          size: 'full',
          children: {
            new: {
              path: 'new',
            },
            documentId: {
              path: ':document_id',
            },
          },
        },
        folderId: {
          level: 2,
          path: ':folderId',
          children: {
            new: {
              path: 'new',
              level: 2,
            },
            documentId: {
              path: ':document_id',
              level: 2,
            },
          },
        },
      },
    },
    notifierDocuments: {
      path: 'notifier-documents/:document_id/recipient/:recipient_id',
      size: 'full',
    },
    managementDocuments: {
      path: 'management-documents',
      size: 'full',
      children: {
        list: {
          path: 'list',
          size: 'full',
          children: {
            new: {
              path: 'new',
            },
            documentId: {
              path: ':document_id',
            },
          },
        },
        folderId: {
          level: 2,
          path: ':folderId',
          children: {
            new: {
              path: 'new',
              level: 2,
            },
            documentId: {
              path: ':document_id',
              level: 2,
            },
          },
        },
      },
    },
    employeeFiles: {
      path: 'employee-files',
      size: 'full',
      children: {
        list: {
          path: 'list',
          size: 'full',
          children: {
            documentId: {
              path: ':document_id',
            },
          },
        },
      },
    },
    bulkFiles: {
      path: 'bulk-files',
      size: 'full',
    },
    documentTemplates: {
      path: 'document-templates',
      size: 'full',
      children: {
        documentTemplateId: {
          path: ':documentTemplateId',
          size: 'full',
        },
      },
    },
    templateVariables: {
      path: 'template-variables',
      size: 'full',
    },
    trash: {
      path: 'trash',
      size: 'full',
      children: {
        employee: {
          path: 'employee',
          children: {
            documentId: {
              path: ':document_id',
            },
          },
        },
        company_public: {
          path: 'company_public',
          children: {
            documentId: {
              path: ':document_id',
            },
          },
        },
        company_internal: {
          path: 'company_internal',
          children: {
            documentId: {
              path: ':document_id',
            },
          },
        },
      },
    },
  },
} as const satisfies Location
